/**
 * @fileoverview Agent definition for the character-extractor-chunked-v2 primitive.
 *
 * This agent is designed for processing large (epic-length) documents in chunks.
 * It takes a text chunk and previously extracted characters, then outputs a
 * merged list following attribute-level additivity rules.
 *
 * Key differences from character-extractor-full-v2:
 * - Accepts `textChunk` instead of `textInput`
 * - Accepts `partialCharacters` for incremental merging
 * - Accepts `chunkInfo` for context about position in document
 * - Prompt is optimized for amendment/merging behavior
 *
 * @category import.characters.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'character-extractor-chunked-v2',
  kind: 'primitive',
  name: 'Chunked Character Extractor',
  description: 'Extracts characters from a text chunk, merging with previously extracted characters. Designed for processing epic-length documents.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'import.characters.extraction.chunked',
    usedBy: ['use-epic-character-import.ts'],
    relatedAgents: ['character-extractor-full-v2', 'character-extractor-targeted-v2'],
  },
};
